import { LocalStoragePanier } from '../store/panier/types';

type Keys = 'panier';
type States = LocalStoragePanier;

export const loadStateFromLocalStorage = (key: Keys): States | undefined => {
	try {
		const serializedState = localStorage.getItem(key);
		if (serializedState === null) return undefined;
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

export const saveStateToLocalStorage = (key: Keys, state: States) => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem(key, serializedState);
	} catch {
		// ignore write errors
	}
};
